import { useState } from "react";
import styles from "./UserProfileImage.module.scss";

export interface UserProfileImageCustomer {
	firstName: string;
	lastName: string;
	image?: string | null;
}

interface UserProfileImageProps {
	customer?: UserProfileImageCustomer | null;
	size: number;
	onClick?: () => void;
	borderColorClass?: string;
}

function getInitials(customer?: UserProfileImageCustomer | null): string {
	const first = customer?.firstName?.charAt(0) ?? "";
	const last = customer?.lastName?.charAt(0) ?? "";
	return `${first}${last}`.toUpperCase();
}

function isValidUrl(url?: string | null): boolean {
	if (!url) return false;
	try {
		const parsed = new URL(url);
		return parsed.protocol === "http:" || parsed.protocol === "https:";
	} catch {
		return false;
	}
}

export default function UserProfileImage({
	customer,
	size,
	onClick,
	borderColorClass,
}: UserProfileImageProps) {
	const [imgError, setImgError] = useState(false);
	const showImage = isValidUrl(customer?.image) && !imgError;
	const fontSize = size > 100 ? 30 : 16;

	return (
		<button
			className={`${styles.wrapper} ${borderColorClass ?? styles.borderDefault}`}
			style={{ width: size, height: size }}
			onClick={onClick}
			disabled={!onClick}
		>
			{showImage ? (
				<img
					src={customer!.image!}
					alt={`${customer?.firstName} ${customer?.lastName}`}
					className={styles.image}
					onError={() => setImgError(true)}
				/>
			) : (
				<span className={styles.initials} style={{ fontSize }}>
					{getInitials(customer)}
				</span>
			)}
		</button>
	);
}
